/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { verify } from "./service";
import Button from "./com/button";
import VerifyInput from "./com/ver-input";
import { countdown } from "./utils";

const VerifyPg = ({ onError }) => {
  const { email, password } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [submitText, setSubmitText] = useState("Confirm");
  const [authCode, setAuthCode] = useState({});
  const [timer, setTimer] = useState([0, 0]);

  const redirect = () => {
    window.location.replace("/interrogations");
  };

  // Starts Countdown Timer
  useEffect(() => {
    countdown(5 * 60, (time) => setTimer(time));
  }, []);

  // This Method Converts VerifyCode Object to plain String
  const formatVerifyResult = (authCodeObject) => Object.values(authCodeObject).join("");

  const setButtonText = (text, cb = () => {}) => {
    setSubmitText(text);
    setTimeout(() => {
      setSubmitText("Confirm");
      cb();
    }, 1500);
  };

  const onVerify = async (e) => {
    e.preventDefault();
    if (formatVerifyResult(authCode).length < 5) {
      setButtonText("Please enter all digits...");
    } else {
      try {
        if (!navigator.onLine) setButtonText("Please enter all digits...");
        else {
          setIsLoading(true);
          const res = await verify(email, password, formatVerifyResult(authCode));
          if (res.token) {
            setIsLoading(false);
            setButtonText("Login Successful...", () => {
              window.localStorage.setItem(
                "genToken",
                JSON.stringify({ user: res.user.username, token: res.token })
              );
              redirect();
            });
          } else {
            setIsLoading(false);
            setButtonText(res.errors[0].msg);
          }
        }
      } catch (error) {
        setIsLoading(false);
        if (onError) onError(error);
        else setButtonText(error.message);
      }
    }
  };

  const handleVerifyInput = (data) => setAuthCode({ ...authCode, ...data });

  return (
    <div className="page">
      <div className="geneva-logo" style={{ transform: "scale(0.6)" }} />
      <div className="root">
        <form onSubmit={onVerify} className="tl-form">
          <div className="area">
            <h1>Two Factor Authentication</h1>
            <span style={{ textAlign: "center" }}>
              A 5-digit code has been sent to your mobile phone. <br /> The code expires in 5 minutes
            </span>
          </div>
          <VerifyInput onChange={handleVerifyInput} />
          {timer[0] !== 0 && timer[1] !== 0 ? <div className="timer">{`${timer[0]}:${timer[1]}`}</div> : null}
          <Button className="btn tl-btn" type="submit" isLoading={isLoading}>
            &nbsp; {submitText}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default VerifyPg;
